/**********Sticky header ************ */
document.addEventListener("DOMContentLoaded", onDOMReady);
function onDOMReady() {
    let menuHeader = document.querySelector('header');
    let body = document.querySelector('body');
    if(menuHeader && body) {
        let stickyEnabled = true;
        const measure = () => {
            stickyEnabled = document.documentElement.scrollHeight > window.innerHeight + 200;
        };
        requestAnimationFrame(measure);
        window.addEventListener('resize', () => requestAnimationFrame(measure), { passive: true });

        let ticking = false;
        window.addEventListener('scroll', () => {
            if (ticking) return;
            ticking = true;
            requestAnimationFrame(() => {
                const top = window.scrollY || document.documentElement.scrollTop || 0;
                if (top > 120 && stickyEnabled) {
                    menuHeader.classList.add("sticky");
                    body.classList.add("sticky-margin-top");
                } else {
                    body.classList.remove("sticky-margin-top");
                    menuHeader.classList.remove("sticky");
                }
                ticking = false;
            });
        }, { passive: true });
    }
}
/* **** Main menu **** */
function mainMenuHandler() {
    const mainMenu = document.querySelector('.main-menu');
    if (!mainMenu) return;
    const menuItems = mainMenu.querySelectorAll('.main-menu__list__item');
    for(let i = 0; i < menuItems.length; i++) {
        if (menuItems[i].classList.contains('current')) break;
        menuItems[i].classList.add('selected');
    }
}
mainMenuHandler();

/* **** Auto resize textarea field **** */
export class ResizeTextArea {
    constructor() {
        this.textarea = document.querySelector('textarea');
        this.rows = this.textarea.getAttribute('rows');
        this.textarea.addEventListener('input', this.autosize.bind(this));
    }

    autosize() {
        const previousRows = this.rows;
        const lines = this.textarea.value.split('\n').length;
        const characters = this.textarea.value.length;
        const rows = Math.max(lines, Math.ceil(characters / this.textarea.cols));
        if (rows !== previousRows) {
            this.textarea.setAttribute('rows', rows);
            this.rows = rows;
            this.textarea.dispatchEvent(new Event('change'));
        }
    }
}

/* **** Rules adding margin after blocks **** */
function marginRules() {
    const sections = document.querySelectorAll('section.product-description-section');
    const productCatalog = document.querySelectorAll('div.product-catalog');
    if(sections && sections.length > 0) {
        sections.forEach(section => {
            if (section.nextElementSibling && section.nextElementSibling.tagName.toLowerCase() === 'div') {
                section.classList.add('has-div');
            }
        });
    }
    if(productCatalog && productCatalog.length > 0) {
        productCatalog.forEach(div => {
            if (div.nextElementSibling && div.nextElementSibling.tagName.toLowerCase() !== 'section') {
                div.classList.add('not-has-section');
            }
        });
    }
}
marginRules();

/* **** Burger **** */
const burgerHandler = () => {
    if (!document.querySelector('.burger-menu')) {
        return;
    }

    const burgerBtn = document.querySelector('.burger-menu');
    const menu = document.querySelector('.main-menu');
    const body = document.querySelector('body');
    const html = document.querySelector('html');
    let scrollPosition = 0;

    const handleMenu = () => {
        burgerBtn.classList.toggle('show');
        menu.classList.toggle('show');
        body.classList.toggle('show');

        const btn = document.querySelector('.main-menu.show a.btn');
        const mainMenuBtn = document.querySelectorAll('.main-menu.show a');

        if (btn) {
            btn.addEventListener('click', closeMenu);
        }

        if (mainMenuBtn.length) {
            mainMenuBtn.forEach(menuBtn => {
                menuBtn.addEventListener('click', closeMenu);
            });
        }

        if (html.classList.contains('show')) {
            html.classList.remove('show');
            window.scrollTo({
                top: scrollPosition,
                behavior: 'instant',
            });
        } else {
            scrollPosition = window.scrollY;
            html.classList.add('show');
        }
    };

    const closeMenu = () => {
        burgerBtn.classList.remove('show');
        menu.classList.remove('show');
        body.classList.remove('show');
        html.classList.remove('show');
        window.scrollTo({
            top: scrollPosition,
            behavior: 'instant',
        });

        removeEventListeners();
    };

    const removeEventListeners = () => {
        const btn = document.querySelector('.main-menu a.btn');
        const mainMenuBtn = document.querySelectorAll('.main-menu a');

        if (btn) {
            btn.removeEventListener('click', closeMenu);
        }

        if (mainMenuBtn.length) {
            mainMenuBtn.forEach(menuBtn => {
                menuBtn.removeEventListener('click', closeMenu);
            });
        }
    };

    burgerBtn.addEventListener('click', handleMenu);

    window.addEventListener('pagehide', removeEventListeners);
};




burgerHandler();

/********** summary widget scrollspy ************/

/********** summary widget scrollspy ************/
const summaryWidgetScrollSpy = () => {
    const links = Array.from(document.querySelectorAll('.article-widget-card--summary a[href^="#"]'));
    if (!links.length) {
        return;
    }
    
    const linkMap = new Map();
    links.forEach((link) => {
        const hash = link.getAttribute('href');
        if (!hash) return;
        const id = decodeURIComponent(hash.replace('#', '').trim());
        if (!id) return;
        const target = document.getElementById(id);
        if (target) {
            linkMap.set(target, link);
        }
    });
    
    if (!linkMap.size) {
        return;
    }
    
    const clearActive = () => {
        links.forEach((link) => link.classList.remove('is-active'));
    };
    
    const observer = new IntersectionObserver((entries) => {
        let bestEntry = null;
        entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            if (!bestEntry || entry.intersectionRatio > bestEntry.intersectionRatio) {
                bestEntry = entry;
            }
        });
        
        if (bestEntry && linkMap.has(bestEntry.target)) {
            clearActive();
            linkMap.get(bestEntry.target).classList.add('is-active');
        }
    }, { rootMargin: '-30% 0px -50% 0px', threshold: [0.1, 0.25, 0.5, 0.75, 1] });
    
    linkMap.forEach((link, target) => observer.observe(target));
};
summaryWidgetScrollSpy();
